import { render, staticRenderFns } from "./AddIntent.vue?vue&type=template&id=59941138&scoped=true"
import script from "./AddIntent.vue?vue&type=script&lang=js"
export * from "./AddIntent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59941138",
  null
  
)

export default component.exports